
<template>

  <div class="atividades-funcionarios ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="4">
                <label for="select-empresa">Empresa</label>
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                <label for="select-garagem_sol">Filial</label> 
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true"    
                   @close="loadFuncionarioSituacao()"               
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-situacao">Situação</label> 
                <multiselect id="selecao-situcao-sol"  v-model="value_situacao" required                   
                  :options="situacoes" 
                  :multiple="true" 
                   :taggable="true"                   
                   @close="loadFuncionarios(), loadFuncionarioSituacao(),loadKpiFilial(), loadKpiFuncao(),loadKpiSituacao(),loadKpiPortalFilial(),loadKpiPortalSituacao(),loadKpiPortalVersao(),loadKpiPortalPercentual()"
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a situação" label="situacao" track-by="situacao" name="situacao"
                  :preselect-first="true">                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Situação selecionada</span></template>
                </multiselect> 
              </b-col>

          </b-row>
    </b-form>   

    <div>
        <b-row id="func_resumo">
          <div>

            <b-card-group class="ml-3 mt-3" deck>               

                    
                      <b-card            
                        id="func_ativo"                  
                        style="width: 33rem;"
                        border-variant="primary"
                        header="FUNCIONÁRIOS ATIVO"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"

                      >
                        <b-card-text> 
                          <h2>                    
                          {{ funcionarios.filter( s => s.id_situacao == 1).length }}
                          </h2>
                        </b-card-text>
                      </b-card>
                    
                    <b-card            
                      id="func_afastado"                      
                      style="width: 33rem;"
                      border-variant="primary"
                      header="FUNCIONÁRIOS AFASTADOS"
                      header-bg-variant="warning"
                      header-text-variant="white"
                      align="center"
                    >
                      <b-card-text> 
                        <h2>
                          {{ funcionarios.filter( s => s.id_situacao != 1 && s.id_situacao != 2 ).length }}
                        </h2>
                        
                        
                      </b-card-text>
                    </b-card>
                    
                    <b-card            
                      id="func_demitido"                      
                      style="width: 33rem;"
                      border-variant="primary"
                      header="FUNCIONÁRIOS DEMITIDOS"
                      header-bg-variant="danger"
                      header-text-variant="white"
                      align="center"
                    >
                      <b-card-text> 
                        <h2>
                          {{ funcionarios.filter( s => s.id_situacao == 2).length }}
                        </h2>
                        
                      </b-card-text>
              </b-card >        
              
                  <b-card
                    
                    id="func_total"              
                    style="width: 33rem;"
                    border-variant="primary"
                    header="TOTAL DE FUNCIONÁRIOS"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    align="center"
                  >
                    <b-card-text > 
                      <h2>
                        {{funcionarios.length}} 
                      </h2>
                      
                    </b-card-text>
                  </b-card>
              
                  <b-card
                    class="mr-4"
                    id="func_app"              
                    style="width: 33rem;"
                    border-variant="primary"
                    header="USUÁRIOS APLICATIVO PORTAL"
                    header-bg-variant="success"
                    header-text-variant="white"
                    align="center"
                  >
                    <b-card-text > 
                      <h2>
                        {{ funcionarios.filter( s => s.app_versao != null).length }}
                      </h2>                
                    </b-card-text>
                  </b-card>              

            </b-card-group>      

          </div>
        </b-row>
    </div>

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        


        <!-- kpi funcionarios  -->
        <b-row>

          <!-- acumulado  FILIAL -->
          <b-col cols="4">
            <apexcharts 
              ref="chartfuncionariofilial"
              height="400" 
              :options="graficoFuncionarioFilial"   
              :series ="graficoFuncionarioFilial.seriesfilial"     
              
            >
            </apexcharts> 
            
                       
          </b-col>

          <!-- acumulado  Função -->
          <b-col cols="4">
            <apexcharts 
            ref="chartfuncao"
            height="400" :options="graficoFuncao" 
            :series="seriesfuncao"></apexcharts>
          </b-col>

          <!-- acumulado  situacao -->
          <b-col cols="4">
            <apexcharts
            ref="chartsituacao" 
            height="400" 
            :options="graficoSituacao" 
            :series="seriessituacao"
            ></apexcharts>
          </b-col>
        </b-row>

        <!-- kpi usuários portal  -->
        <b-row>

          <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts 
              ref="chartportalfilial"
              height="400" 
              :options="graficoAppPortalFilial"   
              :series ="graficoAppPortalFilial.seriesportalfilial"     
              
            >
            </apexcharts> 
            
                       
          </b-col>

          <!-- acumulado  situação portal -->
          <b-col cols="3">
            <apexcharts 
            ref="chartportalsituacao"
            height="400" :options="graficoPortalSituacao" 
            :series="seriesportalsituacao"></apexcharts>
          </b-col>

          <!-- acumulado  versão -->
          <b-col cols="3">
            <apexcharts
            ref="chartportalversao" 
            height="400" 
            :options="graficoPortalVersao" 
            :series="seriesportalversao"
            ></apexcharts>
          </b-col>

          <!-- acumulado  percentual -->
          <b-col cols="3">
            <apexcharts
            ref="chartportalusuarioxfuncionario" 
            height="400" 
            :options="graficoPortalPercentual" 
            :series=" funcionarios.length<=0 ? [0.00] :[ (funcionarios.filter( s => s.app_versao != null).length /  funcionarios.length * 100).toFixed(2) ] "
            ></apexcharts>
          </b-col>
        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'



export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  /* filial */  
    graficoFuncionarioFilial: {
            chart: {
              id: 'pizza-Funcionario-filial',             
              type: 'pie', 
              height: 350,                                      
              foreColor:"black",                         
            },
            labels: [],
            legend: {
              show: true,             
              position: 'bottom',
            },
            title: {
              text: 'Funcionarios por filial',
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize:  '22px',
                fontWeight:  'bold',
                color:  '#263238'
              },
            }
    },

    /* Função */
    graficoFuncao: {
      chart: {
                id: 'bar-departamento',
                type: 'bar',
                height: 350,            
              
                foreColor:"black",
                toolbar: {
                  show: false
                },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)          
        }
      },
      xaxis: {  
        labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },
              categories:[], 
                tickPlacement: 'of'            
      },     
      title: {
        text: 'Top 20 por Funções',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize:  '22px',
          fontWeight:  'bold',
          color:  '#263238'
        },
      }
    },



    /* Situação */
    graficoSituacao: {
      chart: {
                id: 'bar-situacao',
                type: 'bar',
                height: 350,            
              
                foreColor:"black",
                toolbar: {
                  show: false
                },
      },
      plotOptions: {
        bar: {
        //  horizontal: true,
          //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
          
        }
      },
      xaxis: {  
        labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },
              categories:[], 
                tickPlacement: 'of'            
      },     
      title: {
        text: 'Situação',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize:  '22px',
          fontWeight:  'bold',
          color:  '#263238'
        },
      }
    },


    


  /* funcionario    */
    graficoFuncioanrio: {
      chart: {
                id: 'bar-funcionario',
                type: 'bar',
                height: 350,            
              
                foreColor:"black",
                toolbar: {
                  show: false
                },
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      xaxis: {  
              categories:[], 
                tickPlacement: 'of'            
      },     
      title: {
        text: 'Top 10 por funcionários',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize:  '22px',
          fontWeight:  'bold',
          color:  '#263238'
        },
      }
    },

    ///////////////////////////////  usuário app portal
      graficoAppPortalFilial: {
            chart: {
              id: 'pizza-portal-filial',             
              type: 'donut', 
              height: 350,                                      
              foreColor:"black",                         
            },
            labels: [],
            legend: {
              show: true,             
              position: 'bottom',
            },
            title: {
              text: 'Usuários por filial',
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize:  '22px',
                fontWeight:  'bold',
                color:  '#263238'
              },
            }
    },
  
    /* Situação */
graficoPortalSituacao: {
      chart: {
                id: 'bar-situacao',
                type: 'bar',
                height: 350,            
              
                foreColor:"black",
                toolbar: {
                  show: false
                },
      },
      plotOptions: {
        bar: {
        //  horizontal: true,
          //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
          
        }
      },
      xaxis: {  
        labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },
              categories:[], 
                tickPlacement: 'of'            
      },     
      title: {
        text: 'Situação',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize:  '22px',
          fontWeight:  'bold',
          color:  '#263238'
        },
      }
    },

     /* Versão */
graficoPortalVersao: {
      chart: {
                id: 'bar-versao',
                type: 'bar',
                height: 350,            
              
                foreColor:"black",
                toolbar: {
                  show: false
                },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
          
        }
      },
      xaxis: {  
        labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },
              categories:[], 
                tickPlacement: 'of'            
      },     
      title: {
        text: 'Versões instaladas',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize:  '22px',
          fontWeight:  'bold',
          color:  '#263238'
        },
      }
    },

    
    
    /* Percentual */
    graficoPortalPercentual: {
      chart: {
                id: 'RadialBar-percentual',
                type: 'radialBar',
                height: 350,            
              
                foreColor:"black",
                toolbar: {
                  show: false
                },
                colors: ["#20E647"],
      },
        plotOptions: {
    radialBar: {
      hollow: {
        margin: 0,
        size: "78%",
        background: "#293450"
      },
      track: {
        dropShadow: {
          enabled: true,
          top: 2,
          left: 0,
          blur: 4,
          opacity: 0.15
        }
      },
      dataLabels: {
        name: {
          offsetY: -10,
          color: "#fff",
          fontSize: "13px"
        },
        value: {
          color: "#fff",
          fontSize: "30px",
          show: true
        }
      }
    }
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      gradientToColors: ["#87D4F9"],
      stops: [0, 100]
    }
  },
  stroke: {
    lineCap: "round"
  },
  labels: ["Usuários com o aplicativo"]

    },






/* objetos */

  kpifiliais:[],  
  kpifuncao:[],  
  kpisituacao:[],
  
  kpiportalfilial:[],
  kpiportalversao:[],
  kpiportalsituacao:[],
  kpiportalpercentual:[],


  empresa:{}, 
  empresas:[],   // [] lista       
  filial:{}, 
  filiais: [],   // [] lista   
  situacao:{},
  situacoes:[],
  kpifuncionario:[] ,
  kpilinha:[],
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesfuncao:[],
  seriesfilial:[],  
  seriesfuncionario:[],
  serieslinha:[],
  seriessituacao:[],
  seriesportalfilial:[],
  seriesportalsituacao:[],
  seriesportalversao:[],
  seriesportalusuxfun: [],

  status:{},
  statuss:[],
  funcionarios:[],
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_situacao:[],     

        }        
    },

    

    methods: {      

    loadEmpresas() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
    },  
      
    loadFiliais() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
    },

    loadFuncionarioSituacao() {
          const url = `${baseApiUrl}/folha/funcionario/situacao`
          axios.get(url)
              .then(res => {              
              this.situacoes = res.data 
          })
          .catch(showError)
    },

    loadFuncionarios() {
            let corpo = {                    
                "id_empresa": `${this.value_empresa.map(e => e.id_empresa)}`,                     
                "id_filial_erp": `${[this.value_filial.map(a => a.id_filial_erp)]}`,                                                             
                "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`,                                                             
            }; 
            const url = `${baseApiUrl}/flp/funcionario/cad`            
            axios.post(url,corpo)
                  .then(res => {              
                  this.funcionarios = res.data                      
                  })
                  .catch(showError)
                            
    },

        

      /// filtros funcionários por filial

      async loadKpiFilial() {
            let corpo = {    
                  "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                  "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,       
                  "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`                                                                                 
                  
            };
            const url = `${baseApiUrl}/indicadores/folha/funcionario_filial`
            axios.post(url,corpo)
              .then(res => {
                this.kpifiliais = res.data                
                this.updateChartDataFilial();              
              })
              .catch(showError)
      },

      async updateChartDataFilial() {                                                      
              this.graficoFuncionarioFilial.seriesfilial = this.kpifiliais.map(item => parseInt(item.qtd_funcionario));
              this.atualizarFuncionarioFilialLabels()
      },

      async atualizarFuncionarioFilialLabels() {
          this.graficoFuncionarioFilial.labels = await this.kpifiliais.map(item => item.id_filial_erp);        
          this.$refs.chartfuncionariofilial.updateOptions({ labels: this.graficoFuncionarioFilial.labels });              
      },

      /////////////     
      /// filtros por função
      async loadKpiFuncao() {
              let corpo = {    
                  "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                  "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,   
                  "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`                                                                                        
              };
            const url = await `${baseApiUrl}/indicadores/folha/funcionario_funcao`
            axios.post(url,corpo)
              .then(res => {              
              this.kpifuncao = res.data 
              this.updateChartDataFuncao();               
              })
              .catch(showError)
      },
      
      async updateChartDataFuncao() {
        this.seriesfuncao = [{
          name: 'Qtd',
          data: this.kpifuncao.map(item => parseInt(item.qtd_funcionario)),
          }];
        this.$refs.chartfuncao.updateOptions({ xaxis:{
          categories: this.kpifuncao.map(f => f.funcao)
        }  });       
      },

      /// filtros por situação
      async loadKpiSituacao() {
              let corpo = {    
                  "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                  "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,   
                  "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`,                                                                                             
              };
            const url = await `${baseApiUrl}/indicadores/folha/funcionario_situcao`
            axios.post(url,corpo)
              .then(res => {              
              this.kpisituacao = res.data 
              this.updateChartDataSituacao();               
              })
              .catch(showError)
      },
      
      async updateChartDataSituacao() {
        this.seriessituacao = [{
          name: 'Qtd',
          data: this.kpisituacao.map(item => parseInt(item.qtd_funcionario)),
          }];
        this.$refs.chartsituacao.updateOptions({ xaxis:{
          categories: this.kpisituacao.map(f => f.situacao)
        }  });       
      },

      
      /// filtros usuário por filial
      async loadKpiPortalFilial() {
            let corpo = {    
                  "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                  "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,       
                  "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`                                                                                 
                  
            };
            const url = `${baseApiUrl}/indicadores/appportal/portal_filial`
            axios.post(url,corpo)
              .then(res => {
                this.kpiportalfilial = res.data                
                this.updateChartDataPortalFilial();              
              })
              .catch(showError)
      },

      async updateChartDataPortalFilial() {                                                      
              this.graficoAppPortalFilial.seriesportalfilial = this.kpiportalfilial.map(item => parseInt(item.qtd_funcionario));
              this.atualizarLabels()
      },

      async atualizarLabels() {
          this.graficoAppPortalFilial.labels = await this.kpiportalfilial.map(item => item.id_filial_erp);        
          this.$refs.chartportalfilial.updateOptions({ labels: this.graficoAppPortalFilial.labels });              
      },












      //portal situação
      async loadKpiPortalSituacao() {
              let corpo = {    
                  "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                  "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,   
                  "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`,                                                                                             
              };
            const url = await `${baseApiUrl}/indicadores/appportal/portal_situacao`
            axios.post(url,corpo)
              .then(res => {              
              this.kpiportalsituacao = res.data 
              this.updateChartDataPortalSituacao();               
              })
              .catch(showError)
      },
      
      async updateChartDataPortalSituacao() {
        this.seriesportalsituacao = [{
          name: 'Qtd',
          data: this.kpiportalsituacao.map(item => parseInt(item.qtd_funcionario)),
          }];
        this.$refs.chartportalsituacao.updateOptions({ xaxis:{
          categories: this.kpiportalsituacao.map(f => f.situacao)
        }  });       
      },

      //portal versão
      async loadKpiPortalVersao() {
              let corpo = {    
                  "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                  "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,   
                  "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`,                                                                                             
              };
            const url = await `${baseApiUrl}/indicadores/appportal/portal_versao`
            axios.post(url,corpo)
              .then(res => {              
              this.kpiportalversao = res.data 
              this.updateChartDataPortalVersao();               
              })
              .catch(showError)
      },
      
      async updateChartDataPortalVersao() {
        this.seriesportalversao = [{
          name: 'Qtd',
          data: this.kpiportalversao.map(item => parseInt(item.qtd_funcionario)),
          }];
        this.$refs.chartportalversao.updateOptions({ xaxis:{
          categories: this.kpiportalversao.map(v => v.versao)
        }  });       
      },

      //portal percentual
      async loadKpiPortalPercentual() {
              let corpo = {    
                  "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                  "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,   
                  "id_situacao": `${[this.value_situacao.map(s => s.id_situacao)]}`,                                                                                             
              };
            const url = await `${baseApiUrl}/indicadores/appportal/portal_percentual`
            axios.post(url,corpo)
              .then(res => {              
              this.kpiportalpercentual = res.data            
              })
              .catch(showError)
      },
      
      async updateChartDataPortalPercentualo() {
        this.seriesportalusuxfun = [{
          name: 'Qtd',
          data: this.kpiportalversao.map(item => parseInt(item.qtd_funcionario)),
          }];
        this.$refs.chartportalversao.updateOptions({ xaxis:{
          categories: this.kpiportalversao.map(v => v.percetual_usuario)
        }  });       
      },





    },

      

    mounted(){
        this.loadEmpresas()  
        
    },
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>